/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrCloudInstance { 
    /**
     * API endpoint to connect to EDR cloud instance.
     */
    api_endpoint?: string;
    /**
     * The EDR cloud instance id.
     */
    edr_region?: string;
    /**
     * Description of the cloud instance.
     */
    description?: string;
    /**
     * Internal description.
     */
    internal_description?: string;
    /**
     * User who created mapping.
     */
    created_by?: string;
    /**
     * Created timestamp in UTC
     */
    created_timestamp?: Date;
    /**
     * User who created mapping.
     */
    updated_by?: string;
    /**
     * Updated timestamp in UTC
     */
    updated_timestamp?: Date;
}

